import Mustache from 'mustache'
import MESSAGES from 'core/data-model/constants/bi-messages'
import { formatNumber } from 'core/service/lib/number-format'

export const taxDeductionBenefit = (taxDeduction) => taxConsentDeductionBenefit(taxDeduction)

export const taxDeductionBenefit_exist = ({ taxDeduction }) => ({
  stack: [
    { text: MESSAGES.TAX_DEDUCTION_BENEFIT_TITLE, style: 'title' },
    { text: MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_TITLE, bold: true },
    {
      text: `${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION} ${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION_STRONG}`,
    },
    {
      fontSize: 12,
      table: {
        widths: [300, '*'],
        body: [
          [
            MESSAGES.RETIREMENT_TAX_BENEFIT_SUB_LIST[0].description,
            {
              text: Mustache.render(MESSAGES.RETIREMENT_TAX_BENEFIT_SUB_LIST[0].benefit, {
                value: formatNumber(taxDeduction.taxDeductionBasicPremiumForYear, 2, true),
              }),
              alignment: 'right',
            },
          ],
          [
            MESSAGES.RETIREMENT_TAX_BENEFIT_SUB_LIST[1].description,
            {
              text: Mustache.render(MESSAGES.RETIREMENT_TAX_BENEFIT_SUB_LIST[1].benefit, {
                value: formatNumber(taxDeduction.taxDeductionRiderPremuimForYear, 2, true),
              }),
              alignment: 'right',
            },
          ],
        ],
      },
      layout: 'noBorders',
      margin: [36, 0, 30, 0],
    },
    { text: MESSAGES.BI_RETIREMENT_TAX_BENEFIT_SUB_ADDITIONAL, style: 'disclaimer' },
    {
      stack: [
        // MESSAGES.RETIREMENT_TAX_BENEFIT_SUB_ADDITIONAL,
        {
          text: `${MESSAGES.NOTE}: `,
          margin: [0, 10, 0, 0],
        },
        {
          text: `${MESSAGES.BI_RETIREMENT_TAX_BENEFIT_SUB_NOTES[0][0]} ${MESSAGES.BI_RETIREMENT_TAX_BENEFIT_SUB_NOTES[0][1]}`,
          margin: [36, -13, 0, 0],
        },
        {
          text: `${MESSAGES.BI_RETIREMENT_TAX_BENEFIT_SUB_NOTES[1][0]} ${MESSAGES.BI_RETIREMENT_TAX_BENEFIT_SUB_NOTES[1][1]}`,
          margin: [36, 5, 0, 0],
        },
        {
          text: `${MESSAGES.BI_RETIREMENT_TAX_BENEFIT_SUB_NOTES[2][0]}`,
          margin: [36, 10, 0, 0],
        },
      ],
      style: 'disclaimer',
    },
  ],
  style: 'groupRow',
})

export const taxConsentDeductionBenefit = ({ taxDeduction }) => ({
  stack: [
    { text: MESSAGES.TAX_DEDUCTION_BENEFIT_TITLE, style: 'title', marginTop: -20 },
    { text: MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_TITLE, bold: true },
    {
      text: `${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION} ${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION_STRONG}`,
    },
    {
      fontSize: 12,
      table: {
        widths: [300, '*'],
        body: [
          [
            MESSAGES.RETIREMENT_TAX_CONSENT_BENEFIT_SUB_LIST[0].description,
            {
              text: Mustache.render(MESSAGES.RETIREMENT_TAX_CONSENT_BENEFIT_SUB_LIST[0].benefit, {
                value:
                  taxDeduction.taxDeductionRetirementForYear === 0
                    ? '-'
                    : formatNumber(taxDeduction.taxDeductionRetirementForYear, 2, true),
              }),
              alignment: 'right',
            },
          ],
          [
            MESSAGES.RETIREMENT_TAX_CONSENT_BENEFIT_SUB_LIST[1].description,
            {
              text: Mustache.render(MESSAGES.RETIREMENT_TAX_CONSENT_BENEFIT_SUB_LIST[1].benefit, {
                value:
                  taxDeduction.taxDeductionLifeForYear === 0
                    ? '-'
                    : formatNumber(taxDeduction.taxDeductionLifeForYear, 2, true),
              }),
              alignment: 'right',
            },
          ],
          [
            MESSAGES.RETIREMENT_TAX_CONSENT_BENEFIT_SUB_LIST[2].description,
            {
              text: Mustache.render(MESSAGES.RETIREMENT_TAX_CONSENT_BENEFIT_SUB_LIST[2].benefit, {
                value:
                  taxDeduction.taxDeductionHealthForYear === 0
                    ? '-'
                    : formatNumber(taxDeduction.taxDeductionHealthForYear, 2, true),
              }),
              alignment: 'right',
            },
          ],
        ],
      },
      layout: 'noBorders',
      margin: [36, 0, 30, 0],
    },
    { text: MESSAGES.TAX_CONSENT_DEDUCTION_BENEFIT_SUB_ADDITIONAL_PDF, style: 'disclaimer' },
    {
      stack: [
        {
          text: `${MESSAGES.NOTE}: `,
          margin: [0, 10, 0, 0],
        },
        {
          text: `${MESSAGES.BI_RETIREMENT_TAX_CONSENT_BENEFIT_SUB_NOTES[0][0]} ${MESSAGES.BI_RETIREMENT_TAX_CONSENT_BENEFIT_SUB_NOTES[0][1]}`,
          margin: [36, -13, 0, 0],
        },
        {
          text: `${MESSAGES.BI_RETIREMENT_TAX_CONSENT_BENEFIT_SUB_NOTES[1][0]} ${MESSAGES.BI_RETIREMENT_TAX_CONSENT_BENEFIT_SUB_NOTES[1][1]}`,
          margin: [36, 5, 0, 0],
        },
        {
          text: `${MESSAGES.BI_RETIREMENT_TAX_CONSENT_BENEFIT_SUB_NOTES[2][0]} ${MESSAGES.BI_RETIREMENT_TAX_CONSENT_BENEFIT_SUB_NOTES[2][1]}`,
          margin: [36, 5, 0, 0],
        },
      ],
      style: 'disclaimer',
    },
  ],
  style: 'groupRow',
})
